export const SET_SURGERY_DETAILS = 'CONSIGNMENTRETURN: SET_SURGERY_DETAILS';
export const SET_CART_DATA = 'SURGERY: SET_CART_DATA';
export const UPDATE_CART_DATA = 'CONSIGNMENTRETURN: UPDATE_CART_QUANTITY';
export const UPDATE_CART_DATA_SHIPPING = 'SURGERY: UPDATE_CART_DATA_SHIPPING';
export const SET_SHIPPING_DETAILS = 'SURGERY: SET_SHIPPING_DETAILS';
export const SET_SHIPPING_DETAILS_EDIT_MODE = 'SET_SHIPPING_DETAILS_EDIT_MODE';
export const GET_DROPDOWN = 'EQUITY: GET_DROPDOWN';
export const GET_DROPDOWN_SUCCESS = 'EQUITY: GET_DROPDOWN_SUCCESS';
export const GET_DROPDOWN_FAILURE = 'EQUITY: GET_DROPDOWN_FAILURE';
export const SAVE_SURGERY_DETAILS = 'SURGERY: SAVE_SURGERY_DETAILS';
export const SAVE_SURGERY_DETAILS_SUCCESS =
    'SURGERY: SAVE_SURGERY_DETAILS_SUCCESS';
export const SAVE_SURGERY_DETAILS_FAILURE =
    'SURGERY: SAVE_SURGERY_DETAILS_FAILURE';
export const UPDATE_SURGERY_DETAILS = 'SURGERY: UPDATE_SURGERY_DETAILS';
export const UPDATE_SURGERY_DETAILS_SUCCESS =
    'SURGERY: UPDATE_SURGERY_DETAILS_SUCCESS';
export const UPDATE_SURGERY_DETAILS_FAILURE =
    'SURGERY: UPDATE_SURGERY_DETAILS_FAILURE';

export const GET_PRODUCTS = 'EQUITYPRODUCTS:GET_PRODUCTS';
export const GET_PRODUCTS_SUCCESS = 'EQUITYPRODUCTS:GET_PRODUCTS_SUCCESS';
export const GET_PRODUCTS_FAILURE = 'EQUITYPRODUCTS:GET_PRODUCTS_FAILURE';
export const GET_PRODUCTS_BULK = 'EQUITYPRODUCTS:GET_PRODUCTS_BULK';
export const GET_PRODUCTS_BULK_SUCCESS =
    'EQUITYPRODUCTS:GET_PRODUCTS_BULK_SUCCESS';
export const GET_PRODUCTS_BULK_FAILURE =
    'EQUITYPRODUCTS:GET_PRODUCTS_BULK_FAILURE';
export const SET_PRODUCTS = 'EQUITYPRODUCTS:SET_PRODUCTS';
export const CLEAR_PRODUCTS = 'EQUITYPRODUCTS:CLEAR_PRODUCTS';
export const GET_PRODUCTSGUIDE = 'PRODUCTSGUIDE:GET_PRODUCTSGUIDE';
export const GET_PRODUCTSGUIDE_SUCCESS =
    'PRODUCTSGUIDE:GET_PRODUCTSGUIDE_SUCCESS';
export const GET_PRODUCTSGUIDE_FAILURE =
    'PRODUCTSGUIDE:GET_PRODUCTSGUIDE_FAILURE';
export const SET_PRODUCTSGUIDE = 'PRODUCTSGUIDE:SET_PRODUCTSGUIDE';
export const CLEAR_PRODUCTS_GUIDE = 'PRODUCTSGUIDE:CLEAR_PRODUCTS_GUIDE';
export const VALIDATE_PRODUCTS = 'EQUITYPRODUCTS:VALIDATE_PRODUCTS';
export const VALIDATE_PRODUCTS_SUCCESS =
    'EQUITYPRODUCTS:VALIDATE_PRODUCTS_SUCCESS';
export const VALIDATE_PRODUCTS_FAILURE =
    'EQUITYPRODUCTS: VALIDATE_PRODUCTS_FAILURE';
export const CLEAR_VALIDATED_PRODUCTS =
    'EQUITYPRODUCTS: CLEAR_VALIDATED_PRODUCTS';
export const GET_PRODUCTSTEMPLATESFILTER =
    'PRODUCTSTEMPLATESFILTER:GET_PRODUCTSTEMPLATESFILTER';
export const GET_PRODUCTSTEMPLATESFILTER_SUCCESS =
    'PRODUCTSTEMPLATESFILTER:GET_PRODUCTSTEMPLATESFILTER_SUCCESS';
export const GET_PRODUCTSTEMPLATESFILTER_FAILURE =
    'PRODUCTSTEMPLATESFILTER:GET_PRODUCTSTEMPLATESFILTER_FAILURE';
export const SET_PRODUCTSTEMPLATESFILTER =
    'PRODUCTSTEMPLATESFILTER:SET_PRODUCTSTEMPLATESFILTER';
export const SET_PROGRESS_BAR_STATUS =
    'CONSIGNMENTPROGRESSBAR: SET_PROGRESS_BAR_STATUS';
export const RESET_PROGRESS_BAR_STATUS =
    'CONSIGNMENTPROGRESSBAR: RESET_PROGRESS_BAR_STATUS';
export const SET_PROGRESS_BAR_CURRENT_STEP =
    'CONSIGNMENTPROGRESSBAR: SET_PROGRESS_BAR_CURRENT_STEP';
export const SET_PROGRESS_BAR_EDIT_MODE =
    'CONSIGNMENTPROGRESSBAR: SET_PROGRESS_BAR_EDIT_MODE';

export const SET_PROGRESS_BAR_RETURN_STATUS =
    'CONSIGNMENTPROGRESSBAR: SET_PROGRESS_BAR_RETURN_STATUS';
export const RESET_PROGRESS_BAR_RETURN_STATUS =
    'CONSIGNMENTPROGRESSBAR: RESET_PROGRESS_BAR_RETURN_STATUS';
export const SET_PROGRESS_BAR_RETURN_CURRENT_STEP =
    'CONSIGNMENTPROGRESSBAR: SET_PROGRESS_BAR_RETURN_CURRENT_STEP';
export const SET_PROGRESS_BAR_RETURN_EDIT_MODE =
    'CONSIGNMENTPROGRESSBAR: SET_PROGRESS_BAR_RETURN_EDIT_MODE';

export const SET_PRICING_NOTES = 'SET_PRICING_NOTES';
//product details

export const GET_PRODUCT_DETAILS = 'EQUITYPRODUCTS: GET_PRODUCT_DETAILS';
export const GET_PRODUCT_DETAILS_SUCCESS =
    'EQUITYPRODUCTS: GET_PRODUCT_DETAILS_SUCCESS';
export const GET_PRODUCT_DETAILS_ERROR =
    'EQUITYPRODUCTS: GET_PRODUCT_DETAILS_ERROR';
export const SORT_PRODUCT_DETAILS = 'EQUITYPRODUCTS: SORT_PRODUCT_DETAILS';
export const GET_SHIPPING_METHODS = 'CONSIGNMENTSHIPPING: GET_SHIPPING_METHODS';
export const GET_SHIPPING_METHODS_SUCCESS =
    'CONSIGNMENTSHIPPING: GET_SHIPPING_METHODS_SUCCESS';
export const GET_SHIPPING_METHODS_FAILURE =
    'CONSIGNMENTSHIPPING: GET_SHIPPING_METHODS_FAILURE';
export const GET_SHIP_TO_ADDRESS = 'SHIPPING: GET_SHIP_TO_ADDRESS';
export const GET_SHIP_TO_ADDRESS_SUCCESS =
    'SHIPPING: GET_SHIP_TO_ADDRESS_SUCCESS';
export const GET_SHIP_TO_ADDRESS_FAILURE =
    'SHIPPING: GET_SHIP_TO_ADDRESS_FAILURE';
export const SET_SHIP_TO_ADDRESS_DETAILS =
    'SHIPPING: SET_SHIP_TO_ADDRESS_DETAILS';

export const GET_BATCH_ALLOCATIONS = 'SHIPPING: GET_BATCH_ALLOCATIONS';
export const GET_BATCH_ALLOCATIONS_SUCCESS =
    'SHIPPING: GET_BATCH_ALLOCATIONS_SUCCESS';
export const GET_BATCH_ALLOCATIONS_FAILURE =
    'SHIPPING: GET_BATCH_ALLOCATIONS_FAILURE';

export const SET_VISUALIZATION_INSPECTION =
    'SUBMIT: SET_VISUALIZATION_INSPECTION';
//Surgery Notes
export const HANDLE_SURGERY_NOTES = 'HANDLE_SURGERY_NOTES';
export const GET_SURGERY_DETAILS = 'GET_SURGERY_DETAILS';
export const GET_SURGERY_DETAILS_SUCCESS = 'GET_SURGERY_DETAILS_SUCCESS';
export const GET_SURGERY_DETAILS_FAILURE = 'GET_SURGERY_DETAILS_FAILURE';
export const RESET_SURGERY_DETAILS = 'RESET_SURGERY_DETAILS';
export const CHANGE_SHIPPING_SEGMENT_INDEX = 'CHANGE_SHIPPING_SEGMENT_INDEX';
export const CHANGE_SHIPPING_ACKNOWLEGMENT_CHECKOUT =
    'CHANGE_SHIPPING_ACKNOWLEGMENT_CHECKOUT';
export const DISABLE_SURGERY_DATE = 'DISABLE_SURGERY_DATE';
export const CURRENT_SURGERY_DATE_SELECTED = 'CURRENT_SURGERY_DATE_SELECTED';
export const CHANGE_ACKNOWLEGMENT_VIEW = 'CHANGE_ACKNOWLEGMENT_VIEW';

//category data
export const GET_PRODUCT_BRAND_AND_CATEGORY_DATA =
    'GET_PRODUCT_BRAND_AND_CATEGORY_DATA';
export const GET_PRODUCT_BRAND_AND_CATEGORY_DATA_SUCCESS =
    'GET_PRODUCT_BRAND_AND_CATEGORY_DATA_SUCCESS';
export const GET_PRODUCT_BRAND_AND_CATEGORY_DATA_FAILURE =
    'GET_PRODUCT_BRAND_AND_CATEGORY_DATA_FAILURE';
//approach and technology
export const GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY =
    'GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY';
export const GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_SUCCESS =
    'GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_SUCCESS';
export const GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_FAILURE =
    'GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_FAILURE';
// export const SET_UNSAVED_CHANGES_POP_UP = 'SS:SET_UNSAVED_CHANGES_POP_UP';
export const SET_SCHEDULE_SURGERY_CU_IN_PROGRESS =
    'SS:SET_SCHEDULE_SURGERY_CU_IN_PROGRESS';
export const PHYSICIAN_LOAD_ALL_LOADING = 'PHYSICIAN_LOAD_ALL_LOADING';
export const SET_ROUTE_PATH_FOR_SS_UNSAVED_CHANGES_POP_UP =
    'SS:SET_ROUTE_PATH_FOR_SS_UNSAVED_CHANGES_POP_UP';

//set recently used PhysicianS
export const PUT_RECENTLY_USED_PHYSICIANS = 'PUT_RECENTLY_USED_PHYSICIANS';
export const PUT_RECENTLY_USED_PHYSICIANS_SUCCESS =
    'PUT_RECENTLY_USED_PHYSICIANS_SUCCESS';
export const PUT_RECENTLY_USED_PHYSICIANS_FAILURE =
    'PUT_RECENTLY_USED_PHYSICIANS_FAILURE';

//get derived territories (non-interventional)
export const GET_DERIVED_TERRITORIES = 'GET_DERIVED_TERRITORIES';
export const SET_DERIVED_TERRITORIES_SUCCESS =
    'SET_DERIVED_TERRITORIES_SUCCESS';
export const SET_DERIVED_TERRITORIES_FAILURE =
    'SET_DERIVED_TERRITORIES_FAILURE';

//get detailed templates list
export const GET_DETAILED_PRODUCT_TEMPLATE_LIST =
    'CONSIGNMENTRETURN: GET_DETAILED_PRODUCT_TEMPLATE_LIST';
export const GET_DETAILED_PRODUCT_TEMPLATE_LIST_SUCCESS =
    'CONSIGNMENTRETURN: GET_DETAILED_PRODUCT_TEMPLATE_LIST_SUCCESS';
export const GET_DETAILED_PRODUCT_TEMPLATE_LIST_FAILURE =
    'CONSIGNMENTRETURN: GET_DETAILED_PRODUCT_TEMPLATE_LIST_FAILURE';

//get template details with template id
export const GET_TEMPLATE_DETAILS = 'CONSIGNMENTRETURN: GET_TEMPLATE_DETAILS';
export const GET_TEMPLATE_DETAILS_SUCCESS =
    'CONSIGNMENTRETURN: GET_TEMPLATE_DETAILS_SUCCESS';
export const GET_TEMPLATE_DETAILS_FAILURE =
    'CONSIGNMENTRETURN: GET_TEMPLATE_DETAILS_FAILURE';

//create template
export const CREATE_PRODUCT_TEMPLATE =
    'CONSIGNMENTRETURN: CREATE_PRODUCT_TEMPLATE';
export const CREATE_PRODUCT_TEMPLATE_SUCCESS =
    'CONSIGNMENTRETURN: CREATE_PRODUCT_TEMPLATE_SUCCESS';
export const CREATE_PRODUCT_TEMPLATE_FAILURE =
    'CONSIGNMENTRETURN: CREATE_PRODUCT_TEMPLATE_FAILURE';

//update product template
export const UPDATE_PRODUCT_TEMPLATE =
    'CONSIGNMENTRETURN: UPDATE_PRODUCT_TEMPLATE';
export const UPDATE_PRODUCT_TEMPLATE_SUCCESS =
    'CONSIGNMENTRETURN: UPDATE_PRODUCT_TEMPLATE_SUCCESS';
export const UPDATE_PRODUCT_TEMPLATE_FAILURE =
    'CONSIGNMENTRETURN: UPDATE_PRODUCT_TEMPLATE_FAILURE';
// product template
export const GET_DATA_FOR_PRODUCT_TEMPLATE =
    'CONSIGNMENTRETURN: GET_DATA_FOR_PRODUCT_TEMPLATE';
export const GET_DATA_FOR_PRODUCT_TEMPLATE_SUCCESS =
    'CONSIGNMENTRETURN: GET_DATA_FOR_PRODUCT_TEMPLATE_SUCCESS';
export const GET_DATA_FOR_PRODUCT_TEMPLATE_FAILURE =
    'CONSIGNMENTRETURN: GET_DATA_FOR_PRODUCT_TEMPLATE_FAILURE';

export const RESET_CREATE_TEMPLATE = 'CONSIGNMENTRETURN: RESET_CREATE_TEMPLATE';

//Update Template filter refine data (listing)
export const SET_PRODUCT_TEMPLATE_REFINE_DATA =
    'CONSIGNMENTRETURN: SET_PRODUCT_TEMPLATE_REFINE_DATA';
export const SET_PRODCUCT_TEMPLATE_SUB_CATEGORY_LIST =
    'CONSIGNMENTRETURN: SET_PRODCUCT_TEMPLATE_SUB_CATEGORY_LIST';

export const CLEAR_SPECFIC_DROPDOWN_LIST = 'CLEAR_SPECFIC_DROPDOWN_LIST';
export const GET_HOLIDAY_LIST = 'GET_HOLIDAY_LIST';
export const GET_HOLIDAY_LIST_SUCCESS = 'GET_HOLIDAY_LIST_SUCCESS';
export const SET_HOLIDAY_LIST_AND_CALCULATE_LAST_THREE_BUSINESS_DAYS =
    'SET_HOLIDAY_LIST_AND_CALCULATE_LAST_THREE_BUSINESS_DAYS';
export const GET_HOLIDAY_LIST_ERROR = 'GET_HOLIDAY_LIST_ERROR';
export const CLEAR_SHIPPING_ADDRESS = 'CLEAR_SHIPPING_ADDRESS';
export const RESET_CREATE_UPDATE_SURGERY = 'RESET_CREATE_UPDATE_SURGERY';
export const SET_EXPANDED_FILTER_VIEW = 'SET_EXPANDED_FILTER_VIEW';
export const GET_EQUITY_DETAILS = 'EQUITY: GET_EQUITY_DETAILS';
export const GET_EQUITY_DETAILS_SUCCESS = 'EQUITY: GET_EQUITY_DETAILS_SUCCESS';
export const GET_EQUITY_DETAILS_FAILURE = 'EQUITY: GET_EQUITY_DETAILS_FAILURE';
export const SAVE_EQUITY_DETAILS = 'EQUITY: SAVE_EQUITY_DETAILS';
export const SAVE_EQUITY_DETAILS_SUCCESS =
    'EQUITY: SAVE_EQUITY_DETAILS_SUCCESS';
export const SAVE_EQUITY_DETAILS_FAILURE =
    'EQUITY: SAVE_EQUITY_DETAILS_FAILURE';
export const UPDATE_EQUITY_DETAILS = 'EQUITY: UPDATE_EQUITY_DETAILS';
export const UPDATE_EQUITY_DETAILS_SUCCESS =
    'EQUITY: UPDATE_EQUITY_DETAILS_SUCCESS';
export const UPDATE_EQUITY_DETAILS_FAILURE =
    'EQUITY: UPDATE_EQUITY_DETAILS_FAILURE';
export const VALIDATE_ACCOUNT = 'CONSIGNMENTRETURN: VALIDATE_ACCOUNT';
export const VALIDATE_ACCOUNT_SUCCESS = 'CONSIGNMENTRETURN: VALIDATE_ACCOUNT_SUCCESS';
export const VALIDATE_ACCOUNT_FAILURE = 'CONSIGNMENTRETURN: VALIDATE_ACCOUNT_FAILURE';
export const STORE_ITEM_TABLE_DATA = 'CONSIGNMENTRETURN: STORE_ITEM_TABLE_DATA';
export const SET_ALL_ACCOUNT_OWNED_SELECTED =
    'CONSIGNMENT: SET_ALL_ACCOUNT_OWNED_SELECTED';
export const RESET_VALIDATED_DATA = 'CONSIGNMENT: RESET_VALIDATED_DATA';
export const GET_PRICES_FOR_ITEMS = 'CONSIGNMENT: GET_PRICES_FOR_ITEMS';
export const GET_PRICES_FOR_ITEMS_SUCCESS =
    'CONSIGNMENT: GET_PRICES_FOR_ITEMS_SUCCESS';
export const GET_PRICES_FOR_ITEMS_FAILURE =
    'CONSIGNMENT: GET_PRICES_FOR_ITEMS_FAILURE';
export const GET_CONSIGNMENTRETURN_DETAILS =
    'CONSIGNMENTRETURN: GET_CONSIGNMENTRETURN_DETAILS';
export const GET_CONSIGNMENTRETURN_DETAILS_SUCCESS =
    'CONSIGNMENTRETURN: GET_CONSIGNMENTRETURN_DETAILS_SUCCESS';
export const GET_CONSIGNMENTRETURN_DETAILS_FAILURE =
    'CONSIGNMENTRETURN: GET_CONSIGNMENTRETURN_DETAILS_FAILURE';
export const RESET_CONSIGNMENTRETURN_MYCASEREF_REFERENCE =
    'CONSIGNMENTRETURN: RESET_CONSIGNMENTRETURN_MYCASEREF_REFERENCE';

//consignment return submit order-
export const SAVE_CONSIGNMENTRETURN_ORDER =
    'CONSIGNMENTRETURN: SAVE_CONSIGNMENTRETURN_ORDER';
export const SAVE_CONSIGNMENTRETURN_ORDER_SUCCESS =
    'CONSIGNMENTRETURN: SAVE_CONSIGNMENTRETURN_ORDER_SUCCESS';
export const SAVE_CONSIGNMENTRETURN_ORDER_FAILURE =
    'CONSIGNMENTRETURN: SAVE_CONSIGNMENTRETURN_ORDER_FAILURE';

export const GET_USAGE_DETAILS = 'CONSIGNMENT: GET_USAGE_DETAILS';
export const GET_USAGE_DETAILS_SUCCESS =
    'CONSIGNMENT: GET_USAGE_DETAILS_SUCCESS';
export const GET_USAGE_DETAILS_FAILURE =
    'CONSIGNMENT: GET_USAGE_DETAILS_FAILURE';
export const SET_UNSAVED_CHANGES_POP_UP =
    'CONSIGNMENT:SET_UNSAVED_CHANGES_POP_UP';
export const SET_CONSIGNMENT_CU_IN_PROGRESS =
    'CONSIGNMENT:SET_CONSIGNMENT_CU_IN_PROGRESS';
export const SET_ROUTE_PATH_FOR_CONSIGNMENT_UNSAVED_CHANGES_POP_UP =
    'CONSIGNMENT:SET_ROUTE_PATH_FOR_CONSIGNMENT_UNSAVED_CHANGES_POP_UP';
export const GET_INVENTORY_DATA = 'CONSIGNMENTRETURN:GET_INVENTORY_DATA';
export const GET_INVENTORY_DATA_SUCCESS =
    'CONSIGNMENTRETURN:GET_INVENTORY_DATA_SUCCESS';
export const GET_INVENTORY_DATA_FAILURE =
    'CONSIGNMENTRETURN:GET_INVENTORY_DATA_FAILURE';
export const SET_PRICE_OVERRIDE_DETAILS = 'SET_PRICE_OVERRIDE_DETAILS';
export const RESET_ITEMTABLE_DATA = 'RESET_ITEMTABLE_DATA';
export const RESET_IS_FOR_REPLEN = 'CONSIGNMENT: RESET_IS_FOR_REPLEN';
export const VALIDATE_PRODUCT_DETAILS =
    'CONSIGNMENTRETURN: VALIDATE_PRODUCT_DETAILS';
export const VALIDATE_PRODUCT_DETAILS_SUCCESS =
    'CONSIGNMENTRETURN: VALIDATE_PRODUCT_DETAILS_SUCCESS';
export const VALIDATE_PRODUCT_DETAILS_FAILURE =
    'CONSIGNMENTRETURN: VALIDATE_PRODUCT_DETAILS_FAILURE';
export const SAVE_CONSIGNMENTRETURN_DETAILS =
    'CONSIGNMENTRETURN: SAVE_CONSIGNMENTRETURN_DETAILS';
export const RESET_CONSIGNMENT_RETURN_ORDER =
    'CONSIGNMENTRETURN: RESET_CONSIGNMENT_RETURN_ORDER';
export const SET_INVENTORY_ITEMS_DETAILS =
    'CONSIGNMENTRETURN:SET_INVENTORY_ITEMS_DETAILS';

export const SET_CHANGED_INDEX = 'SET_CHANGED_INDEX';

export const setSurgeryDetails = (surgeryDetails) => {
    return {
        type: SET_SURGERY_DETAILS,
        payload: surgeryDetails,
    };
};

//
export const saveSurgery = (surgeryDetails) => {
    return {
        type: SAVE_SURGERY_DETAILS,
        payload: surgeryDetails,
    };
};

export const updateSurgery = (surgeryDetails) => {
    return {
        type: UPDATE_SURGERY_DETAILS,
        payload: surgeryDetails,
    };
};

export const applyShipToAdderess = (shippingDetails) => {
    return {
        type: SET_SHIP_TO_ADDRESS_DETAILS,
        payload: shippingDetails,
    };
};

export const setCartData = (cartData) => {
    return {
        type: SET_CART_DATA,
        payload: cartData,
    };
};

export const updateCartData = (operation, productKey, isSet) => {
    return {
        type: UPDATE_CART_DATA,
        payload: { operation, productKey, isSet },
    };
};

export const updateCartDataShipping = (newFields, productKeys) => {
    return {
        type: UPDATE_CART_DATA_SHIPPING,
        payload: { newFields, productKeys },
    };
};

export const setShippingDetails = (shippingDetails) => {
    return {
        type: SET_SHIPPING_DETAILS,
        payload: shippingDetails,
    };
};

export const setShippingDetailsEditMode = (shippingDetails) => {
    return {
        type: SET_SHIPPING_DETAILS_EDIT_MODE,
        payload: shippingDetails,
    };
};

export const getDropdownValues = (dropDownDetails) => {
    return {
        type: GET_DROPDOWN,
        payload: dropDownDetails,
    };
};
export const setProductsGuide = (productsGuideList, name) => {
    return {
        type: SET_PRODUCTSGUIDE,
        payload: productsGuideList,
        name: name,
    };
};

export const searchProducts = (queryParam) => {
    return {
        type: GET_PRODUCTS,
        payload: queryParam,
    };
};

export const searchProductsBulk = (cfns) => {
    return {
        type: GET_PRODUCTS_BULK,
        payload: cfns,
    };
};

export const clearProducts = () => {
    return {
        type: CLEAR_PRODUCTS,
    };
};

export const getProductsGuide = () => {
    return {
        type: GET_PRODUCTSGUIDE,
    };
};

export const sortProductDetails = (data) => {
    return {
        type: SORT_PRODUCT_DETAILS,
        payload: data,
    };
};
export const setProgressBarStatus = (completedStep) => {
    return {
        type: SET_PROGRESS_BAR_RETURN_STATUS,
        payload: completedStep,
    };
};

export const reSetProgressBarStatus = () => {
    return {
        type: RESET_PROGRESS_BAR_RETURN_STATUS,
    };
};

export const setProgressBarCurrentStep = (currentStep) => {
    return {
        type: SET_PROGRESS_BAR_RETURN_CURRENT_STEP,
        payload: currentStep,
    };
};

export const setProgressBarStateEditMode = (data) => {
    return {
        type: SET_PROGRESS_BAR_RETURN_EDIT_MODE,
        payload: data,
    };
};

export const validateProducts = (products) => {
    return {
        type: VALIDATE_PRODUCTS,
        payload: products,
    };
};

export const clearValidatedProducts = () => {
    return {
        type: CLEAR_VALIDATED_PRODUCTS,
    };
};

export const getProductDetails = (data) => {
    return {
        type: GET_PRODUCT_DETAILS,
        payload: data,
    };
};

export const getProductsTemplatesFilter = () => {
    return {
        type: GET_PRODUCTSTEMPLATESFILTER,
    };
};

export const setProductsTemplatesFilter = (productsTemplatesFilter) => {
    return {
        type: SET_PRODUCTSTEMPLATESFILTER,
        payload: productsTemplatesFilter,
    };
};

export const getShippingMethods = (payload) => {
    return {
        type: GET_SHIPPING_METHODS,
        payload,
    };
};

export const getShipToAddress = () => {
    return {
        type: GET_SHIP_TO_ADDRESS,
    };
};

export const getShippingBatchAllocations = (cfn) => {
    return {
        type: GET_BATCH_ALLOCATIONS,
        payload: cfn,
    };
};
export const handleSurgeryNotes = (data) => {
    return {
        type: HANDLE_SURGERY_NOTES,
        payload: data,
    };
};
export const setPricingNotes = (data) => {
    return {
        type: SET_PRICING_NOTES,
        payload: data,
    };
};
export const setVisualizationInspection = (value) => {
    return {
        type: SET_VISUALIZATION_INSPECTION,
        payload: value,
    };
};
export const getSurgeryDetails = (myCaseRef, updateState) => {
    return {
        type: GET_SURGERY_DETAILS,
        payload: { myCaseRef, updateState },
    };
};
export const resetSurgeryDetails = () => {
    return {
        type: RESET_SURGERY_DETAILS,
        payload: '',
    };
};
export const changeShippingSegmentIndex = (index) => {
    return {
        type: CHANGE_SHIPPING_SEGMENT_INDEX,
        payload: index,
    };
};
export const changeAcknowlegmentCheckbox = (data) => {
    return {
        type: CHANGE_SHIPPING_ACKNOWLEGMENT_CHECKOUT,
        payload: data,
    };
};
export const changeAcknowlegmentView = (data) => {
    return {
        type: CHANGE_ACKNOWLEGMENT_VIEW,
        payload: data,
    };
};
export const disableSurgeryDate = (value) => {
    return {
        type: DISABLE_SURGERY_DATE,
        payload: value,
    };
};
export const currentSurgeryDateSelected = (value) => {
    return {
        type: CURRENT_SURGERY_DATE_SELECTED,
        payload: value,
    };
};

export const getProductsCategoryAndBrands = (data) => {
    return {
        type: GET_PRODUCT_BRAND_AND_CATEGORY_DATA,
        payload: data,
    };
};

export const getProductsByBrandOrSuperCategory = (data) => {
    return {
        type: GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY,
        payload: data,
    };
};

export const setScheduleSurgeryUnsavedChangesPopUp = (value) => {
    return {
        type: SET_UNSAVED_CHANGES_POP_UP,
        payload: value,
    };
};
export const setScheduleSurgeryCUInProgress = (value) => {
    return {
        type: SET_SCHEDULE_SURGERY_CU_IN_PROGRESS,
        payload: value,
    };
};
export const loadAllPhyscianLoading = (data) => {
    return {
        type: PHYSICIAN_LOAD_ALL_LOADING,
        payload: data,
    };
};
export const putRecentlyUsedPhysicians = () => {
    return {
        type: PUT_RECENTLY_USED_PHYSICIANS,
    };
};
export const setRoutePathForSSUnsavedChangesPopUp = (value) => {
    return {
        type: SET_ROUTE_PATH_FOR_SS_UNSAVED_CHANGES_POP_UP,
        payload: value,
    };
};

export const getDerivedTerritories = (value) => {
    return {
        type: GET_DERIVED_TERRITORIES,
        payload: value,
    };
};

export const getDetailedProductTemplateList = (params) => {
    return {
        type: GET_DETAILED_PRODUCT_TEMPLATE_LIST,
        payload: params,
    };
};

export const getTemplateDetails = (params) => {
    return {
        type: GET_TEMPLATE_DETAILS,
        payload: params,
    };
};

export const createTemplate = (params) => {
    return {
        type: CREATE_PRODUCT_TEMPLATE,
        payload: params,
    };
};

export const resetCreateTemplate = () => {
    return {
        type: RESET_CREATE_TEMPLATE,
    };
};

export const updateProductTemplate = (params) => {
    return {
        type: UPDATE_PRODUCT_TEMPLATE,
        payload: params,
    };
};

export const getRequiredDataFromOrder = (params) => {
    return {
        type: GET_DATA_FOR_PRODUCT_TEMPLATE,
        payload: params,
    };
};

export const clearSingleDropDownList = (value) => {
    return {
        type: CLEAR_SPECFIC_DROPDOWN_LIST,
        payload: value,
    };
};
export const getHolidayList = (data) => {
    return {
        type: GET_HOLIDAY_LIST,
        payload: data,
    };
};
export const clearShippingAddress = (data) => {
    return {
        type: CLEAR_SHIPPING_ADDRESS,
        payload: data,
    };
};
export const resetCreateOrUpdateSurgery = () => {
    return {
        type: RESET_CREATE_UPDATE_SURGERY,
    };
};

export const setExpandedFilters = (data) => {
    return {
        type: SET_EXPANDED_FILTER_VIEW,
        payload: data,
    };
};

export const clearProductsGuide = () => {
    return {
        type: CLEAR_PRODUCTS_GUIDE,
    };
};

export const getEquityDetails = (params) => {
    return {
        type: GET_EQUITY_DETAILS,
        payload: params,
    };
};

export const saveEquity = (equityDetails) => {
    return {
        type: SAVE_EQUITY_DETAILS,
        payload: equityDetails,
    };
};

export const updateEquity = (equityDetails) => {
    return {
        type: UPDATE_EQUITY_DETAILS,
        payload: equityDetails,
    };
};

export const getValidateAccountDetails = (params) => {
    return {
        type: VALIDATE_ACCOUNT,
        payload: params,
    };
};

export const storeItemTableData = (itemTableData) => {
    return {
        type: STORE_ITEM_TABLE_DATA,
        payload: itemTableData,
    };
};

export const setAllAccountOwned = (value) => ({
    type: SET_ALL_ACCOUNT_OWNED_SELECTED,
    payload: value,
});

export const resetValidatedData = () => ({
    type: RESET_VALIDATED_DATA,
});

export const getPricesForItems = (priceItemsObj) => ({
    type: GET_PRICES_FOR_ITEMS,
    payload: priceItemsObj,
});

export const getConsignmentReturnDetails = (params) => {
    return {
        type: GET_CONSIGNMENTRETURN_DETAILS,
        payload: params,
    };
};

export const resetConsignmentReturnMyCaseRefReference = () => ({
    type: RESET_CONSIGNMENTRETURN_MYCASEREF_REFERENCE,
});

export const saveConsignmentReturnDetails = (payload) => {
    return {
        type: SAVE_CONSIGNMENTRETURN_DETAILS,
        payload: payload,
    };
};

export const postConsignmentReturnOrder = (data) => {
    return {
        type: SAVE_CONSIGNMENTRETURN_ORDER,
        payload: data,
    };
};

export const fetchUsageDetailsRequest = (queryParams) => ({
    type: GET_USAGE_DETAILS,
    payload: queryParams,
});

export const setRoutePathForConsignmentUnsavedChangesPopUp = (value) => {
    return {
        type: SET_ROUTE_PATH_FOR_CONSIGNMENT_UNSAVED_CHANGES_POP_UP,
        payload: value,
    };
};
export const setConsignmentUnsavedChangesPopUp = (value) => {
    return {
        type: SET_UNSAVED_CHANGES_POP_UP,
        payload: value,
    };
};
export const setConsignmentCUInProgress = (value) => {
    return {
        type: SET_CONSIGNMENT_CU_IN_PROGRESS,
        payload: value,
    };
};

export const getInventoryDetails = (payload) => {
    return {
        type: GET_INVENTORY_DATA,
        payload: payload,
    };
};

export const setPriceOverrideDetails = (value) => {
    return {
        type: SET_PRICE_OVERRIDE_DETAILS,
        payload: value,
    };
};

export const resetItemTableData = () => {
    return {
        type: RESET_ITEMTABLE_DATA,
        payload: '',
    };
};

export const validateProductDetails = (reqBody) => ({
    type: VALIDATE_PRODUCT_DETAILS,
    payload: { reqBody },
});

export const resetIsForReplen = (payload) => {
    return {
        type: RESET_IS_FOR_REPLEN,
        payload: payload,
    };
};

export const resetConsignmentReturnOrder = () => {
    return {
        type: RESET_CONSIGNMENT_RETURN_ORDER,
    };
};

export const setInventoryItemsDetails = (checkedItems) => {
    return {
        type: SET_INVENTORY_ITEMS_DETAILS,
        payload: checkedItems,
    };
};

export const setChangedIndex = (checkedItems) => {
    return {
        type: SET_CHANGED_INDEX,
        payload: checkedItems,
    };
};
